<template>
  <!-- 盒子管理-盒子奖品-同步对战概率 -->
  <div>
    <el-dialog
      :visible.sync="showMark"
      :close-on-click-modal="false"
      title="同步对战概率"
      width="800px"
      @close="closeDialog"
      center
    >
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="submit">同步概率</el-button>
        </el-form-item>
      </el-form>
      <el-table
        height="300px"
        class="from-overview"
        v-loading="loading"
        :data="dataList"
      >
        <el-table-column prop="prize_name" label="奖品名称" align="center">
        </el-table-column>
        <el-table-column
          prop="min"
          label="概率最小值"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="max"
          label="概率最小值"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { server, postData, delData, patchData, getData, postApiData } from '../../http'

export default {
  components: {
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    visible: {//展示标志
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//加载按钮动画
      dataList: undefined,//数据列表
      dataMeta: undefined,//不底部分页
    }
  },
  computed: {
    ...mapState({
    }),
    showMark: {
      get() {
        return this.visible
      },
      set(bool) {
      }
    },
    boxId: {
      get() {
        return this.value
      },
      set(bool) {
      }
    }
  },
  watch: {
    showMark(val) {
      if (val && this.value) {
        this.getData()//获取数据列表
      }
    }
  },
  created() {
  },
  mounted() { },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['']),
    getData() {
      //获取数据列表
      this.loading = true
      getData(`prize_battle_list/${Number(this.boxId)}`)
        .then(res => {
          this.dataList = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    submit() {
      //同步概率
      this.$confirm('确定要同步到对战概率吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        postData(`prize_battle/${this.boxId}`).then(res => {
          this.$message.success("操作成功！")
          this.closeDialog()//关闭弹窗
        })
      }).catch(() => {
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }

  }

}
</script>
<style lang="less" scoped>
</style>